import { useEffect, useState } from "react"

import { fetchJsonCached, getCachedJson } from "@/shared/lib/cached-json"

import type { PalmReadingContent } from "../types"

const PALM_CONTENT_URL = "/json/palm-reading.json"

/** Loads the static palm-reading copy bank (`public/json/palm-reading.json`) once. */
export function usePalmContent() {
  const [content, setContent] = useState<PalmReadingContent | null>(
    () => getCachedJson<PalmReadingContent>(PALM_CONTENT_URL) ?? null,
  )

  useEffect(() => {
    if (content) return
    let cancelled = false
    fetchJsonCached<PalmReadingContent>(PALM_CONTENT_URL)
      .then((data) => {
        if (!cancelled) setContent(data)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [content])

  return content
}
